import React from "react";
import {Container, Row, Col} from "react-bootstrap";

import cctvIcon from "../../images/rne/tabs/cctv.svg";
import publicWifiIcon from "../../images/rne/tabs/publicwifi.svg";
import smartTvIcon from "../../images/rne/tabs/smarttv.svg";
import smartHomeIcon from "../../images/rne/tabs/smarthome.svg";
import fibreConnectedIcon from "../../images/rne/tabs/fibreconnected.svg";
import phoneServiceIcon from "../../images/rne/tabs/phoneservice.svg";

export default function EnhanceUsabilitySpaces() {
  return (
    <Container fluid className="p-4">
      <Row>
        <Col>
          <div className="tab-main-title">
            {"We offer various services on our network without cost to the developer"}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={4} className="my-4">
          <Row>
            <Col xs={12} sm={2} md={3}>
              <img className="tab-img" src={publicWifiIcon} alt="public wifi icon" />
            </Col>
            <Col>
              <div className="tab-desc align-middle">
                {"Public Wi-Fi"}
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={4} className="my-4">
          <Row>
            <Col xs={12} sm={2} md={3}>
              <img className="tab-img" src={smartTvIcon} alt="Smart TV Icon" />
            </Col>
            <Col>
              <div className="tab-desc align-middle">
                  <div>{"MATV"}</div>
                  <div>{"(free-to-air, Foxtel)"}</div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={4} className="my-4">
          <Row>
            <Col xs={12} sm={2} md={3}>
              <img className="tab-img" src={cctvIcon} alt="cctv icon" />
            </Col>
            <Col>
              <div className="tab-desc align-middle">
                {"Security CCTV"}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col xs={12} md={4} className="my-4">
          <Row>
            <Col xs={12} sm={2} md={3}>
              <img className="tab-img" src={smartHomeIcon} alt="smart home icon" />
            </Col>
            <Col>
              <div className="tab-desc align-middle">
                {"Smart home, IoT"}
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={4} className="my-4">
          <Row>
            <Col xs={12} sm={2} md={3}>
              <img className="tab-img" src={fibreConnectedIcon} alt="fibre connected" />
            </Col>
            <Col>
              <div className="tab-desc align-middle">
                  <div>{"Fibre Connected"}</div>
                  <div>{"(FTTP & FTTB Solutions)"}</div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={4} className="my-4">
          <Row>
            <Col xs={12} sm={2} md={3}>
              <img className="tab-img" src={phoneServiceIcon} alt="phone service icon" />
            </Col>
            <Col>
              <div className="tab-desc align-middle">
                <div>{"Phone Service"}</div>
                <div>{"(VoIP)"}</div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}